<template>
  <div v-if="visivel" class="caixa-modal-overlay" :class="{ 'caixa-modal-overlay--locked': bloqueante }" @click.self="bloqueante ? null : $emit('fechar')">
    <div class="caixa-modal">
      <header class="caixa-modal__header">
        <h3>
          <i class="fas fa-cash-register"></i>
          Abrir Caixa
        </h3>
        <button v-if="!bloqueante" class="caixa-modal__close" @click="$emit('fechar')">×</button>
      </header>

      <div class="caixa-modal__body">
        <p v-if="bloqueante" class="caixa-modal__alert">
          <i class="fas fa-exclamation-triangle"></i>
          Não é possível vender sem caixa aberto. Informe o valor de abertura para liberar o PDV.
        </p>

        <label class="caixa-modal__label">Valor de abertura <span style="color:#dc2626">*</span></label>
        <input
          ref="valorInput"
          v-model.number="valorAbertura"
          type="number"
          min="0.01"
          step="0.01"
          required
          class="caixa-modal__input caixa-modal__input--valor"
          @keydown.enter.prevent="confirmar"
        />

        <label class="caixa-modal__label">Observação (opcional)</label>
        <textarea
          v-model="observacao"
          rows="2"
          class="caixa-modal__input"
          placeholder="Ex.: Troco inicial, turno..."
        ></textarea>

        <p v-if="erro" class="caixa-modal__error">
          <i class="fas fa-exclamation-circle"></i> {{ erro }}
        </p>
      </div>

      <footer class="caixa-modal__footer">
        <button v-if="!bloqueante" class="btn btn-light" :disabled="abrindo" @click="$emit('fechar')">
          Cancelar
        </button>
        <button class="btn btn-success" :disabled="abrindo" @click="confirmar">
          <span v-if="abrindo">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Abrindo...
          </span>
          <span v-else>
            <i class="fas fa-lock-open mr-1"></i> Abrir Caixa
          </span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import CaixaPdvDesktopService from "@/modules/PdvDesktop/services/CaixaPdvDesktopService";

export default {
  name: "AbrirCaixaModal",
  props: {
    visivel:    { type: Boolean, default: false },
    bloqueante: { type: Boolean, default: false },
  },
  data() {
    return {
      valorAbertura: "",
      observacao:    "",
      erro:          "",
      abrindo:       false,
    };
  },
  watch: {
    visivel: {
      immediate: true,
      handler(v) {
        if (!v) return;
        this.valorAbertura = "";
        this.erro = "";
        this.$nextTick(() => this.$refs.valorInput && this.$refs.valorInput.focus());
      },
    },
  },
  methods: {
    async confirmar() {
      this.erro = "";
      const valor = Number(this.valorAbertura);
      if (!Number.isFinite(valor) || valor <= 0) {
        this.erro = "Informe um valor de abertura maior que zero.";
        return;
      }
      this.abrindo = true;
      try {
        const caixa = await CaixaPdvDesktopService.abrirCaixa({
          valor_abertura: valor,
          observacao:     this.observacao,
        });

        // A abertura já foi persistida. Libera o PDV antes de informar qualquer
        // falha acessória, como a ausência de uma impressora configurada.
        this.$emit("aberto", caixa);
        this.valorAbertura = "";
        this.observacao    = "";

        if (caixa && caixa.impressao && caixa.impressao.ok === false) {
          const mensagem =
            "Caixa aberto, mas não foi possível imprimir o comprovante. Você poderá reimprimir depois.";
          if (this.$toast && typeof this.$toast.warning === "function") {
            this.$toast.warning(mensagem);
          } else {
            console.warn(
              `[AbrirCaixaModal] ${mensagem}`,
              caixa.impressao.error || ""
            );
          }
        }
      } catch (e) {
        this.erro = e.message || "Erro ao abrir caixa.";
      } finally {
        this.abrindo = false;
      }
    },
  },
};
</script>

<style scoped>
.caixa-modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 4000;
}
.caixa-modal-overlay--locked { background: rgba(0,0,0,0.75); }
.caixa-modal {
  background: #fff; border-radius: 8px;
  width: 100%; max-width: 440px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.3);
  display: flex; flex-direction: column;
  overflow: hidden;
}
.caixa-modal__header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px; border-bottom: 1px solid #e5e7eb;
}
.caixa-modal__header h3 { margin: 0; font-size: 1.15rem; color: #1f2937; }
.caixa-modal__header h3 i { color: #16a34a; margin-right: 6px; }
.caixa-modal__close {
  background: transparent; border: 0; font-size: 1.6rem; cursor: pointer; color: #6b7280;
}
.caixa-modal__body { padding: 18px 20px; }
.caixa-modal__alert {
  background: #fef3c7; color: #92400e; padding: 10px 12px;
  border-radius: 6px; font-size: 0.9rem; margin-bottom: 14px;
}
.caixa-modal__label {
  display: block; font-size: 0.85rem; color: #4b5563; margin: 10px 0 4px;
}
.caixa-modal__input {
  width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 6px;
  font-size: 0.95rem;
}
.caixa-modal__input--valor { font-size: 1.4rem; font-weight: 600; text-align: right; }
.caixa-modal__error { color: #b91c1c; font-size: 0.85rem; margin-top: 10px; }
.caixa-modal__footer {
  display: flex; justify-content: flex-end; gap: 8px;
  padding: 14px 20px; background: #f9fafb; border-top: 1px solid #e5e7eb;
}
</style>
